import React from 'react';

/**
 * DataTable - Simple reusable table with empty state.
 */
const DataTable = ({ columns = [], data = [], emptyText = 'No data available' }) => {
    if (!data.length) {
        return (
            <div className="sd-data-table__empty">
                {emptyText}
            </div>
        );
    }

    return (
        <div className="sd-data-table-wrapper">
            <table className="sd-data-table">
                <thead className="sd-data-table__head">
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col.key}
                                className="sd-data-table__head-cell"
                                style={col.width ? { width: col.width } : undefined}
                            >
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="sd-data-table__body">
                    {data.map((row, rowIndex) => (
                        <tr
                            key={row.id || rowIndex}
                            className="sd-data-table__row"
                        >
                            {columns.map((col) => (
                                <td key={col.key} className="sd-data-table__cell">
                                    {col.render ? col.render(row, rowIndex) : row[col.key]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DataTable;
